import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { localPersistStorage } from "~/lib/persist-storage";
import { AppointmentFormData } from "../schemas";
import { Appointment } from "../types";

type AppointmentFormType = AppointmentFormData & {
  date: Date;
  time: string;
  timeZone: string;
  message: string;
};

type FormType = {
  step: number;
  data: AppointmentFormType;
  appointment: Appointment;
  setStep: (newStep: number) => void;
  setAppointmentForm: (data: AppointmentFormType) => void;
  setAppointment: (data: Appointment) => void;
  clearForm: () => void;
};

const initialState = {
  step: 1,
  data: {} as AppointmentFormType,
  appointment: {} as Appointment,
};

export const useAppointmentFormStore = create<FormType>()(
  persist(
    (set) => ({
      ...initialState,
      setStep: (newStep) => set({ step: newStep }),
      setAppointmentForm: (data) => set({ data }),
      setAppointment: (data) => set({ appointment: data }),
      clearForm: () => set({ ...initialState }),
    }),
    {
      name: "appointment-form-storage",
      storage: createJSONStorage(() => localPersistStorage),
    },
  ),
);


